import { render, staticRenderFns } from "./creditsCosts.vue?vue&type=template&id=2ed3252f&scoped=true&"
import script from "./creditsCosts.vue?vue&type=script&lang=js&"
export * from "./creditsCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed3252f",
  null
  
)

export default component.exports